import React, { useState,useEffect,useCallback } from "react";
import api from "views/auth/Api";
import "./library.css";
import { GiCrownCoin } from "react-icons/gi";
import { FaRegWindowClose } from "react-icons/fa";
import Points from "./points"
import { message } from 'antd';
import { jwtDecode } from "jwt-decode";
import { API_BASE_URL } from '../../../configs/AppConfig';
import { FILES_URL } from '../../../configs/AppConfig';



const Library = () => {

    const [data , setData] = useState([]);
    const [selected , setSelected] = useState([]);
    const [point , setPoint] = useState(null);
    const [open , setOpen] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);


      const limit = 20; 
      const token = localStorage.getItem('token');
      const decoded = jwtDecode(token);
      const studentId = decoded.id;
      
      const success = () => {
           message.success('Your Redeem Request has been sent');
          };

 const getPoints = async(studentId)=> {
      await api.get(`${API_BASE_URL}student/points/${studentId}`)
      .then((response) => {  
      setPoint(response.data);
      })
      .catch((error) => {
        console.error('Error fetching card:', error);
      });

}  
     useEffect(() => {
      getPoints(studentId)
  }, [studentId]);

    const getData = useCallback(async () => {
      await api.get(`${API_BASE_URL}library`, {
      params: { page, limit },
    })
    .then(function (response) {
              console.log("handlesubmit  ", response.data)
          setData(response.data?.items)
          setTotalPages(response.data.totalPages);
    }).catch(error => {
      console.log("handlesubmit error for blog get ", error)
    });
    }, [page, limit])

    useEffect(()=>{ 
      getData();
    },[getData]);

    const redeemReq = async(id) => {
        setOpen(false);
         await api.post(`${API_BASE_URL}redeem-reqests`, {
        library: id,
      })
          .then(function (response) {
           console.log("handlesubmit  ", response.data);
              setPoint(response.data);
              success();
          }).catch(error => {
            console.log("handlesubmit error for blog get ", error)
          });
        }
    
    const isValid = point >= selected.points;
    
    const redemModel=(library)=>{  
      setOpen(true)
      setSelected(library)
    }
      const onClose = () => {
          setOpen(false);
        }
  const popRedeem =()=>{
    return(
      <div className="teacherModal"> <div className="popRedem">
           <FaRegWindowClose className="windowClose" onClick={() => onClose()} />
                   {isValid ?<h4>Do you want to redeem this model ?</h4> :null}
                {!isValid ? <h4> Sorry not enough points to redeem !</h4> :null}
                   <p>( {selected.model3d?.modelName} model )</p>
                   <div className="btnRedeems">
                <button className={isValid ? "Redeem" : "noRedeem"} disabled={!isValid} onClick={() => redeemReq(selected.id)}>Redeem</button>
               <button className="Redeem" onClick={() => onClose()}>Cancel</button>
              </div>
                </div> </div>
    )
  }
  
  return (
      <div className="h-fit w-full">
        <div className="libraryHeader">
          <div className="libraryH">
          <h1>3D Models Library</h1>
          {/* <div className="btnDev">
            <span>All Categories </span>
            <div className="btnImg"></div>
          </div> */}
          </div>
          {/* <div className="libraryheaderImg"></div> */}
          <Points points={point} />
        </div>
        {/* library cards */}
        <div className="z-20 library-continar">
              {data.map(library =>
              <div>
            <div className="libraryCards redemModel" onClick={() => redemModel(library) } style={{backgroundImage:`url(${FILES_URL}${library?.model3d?.img?.url})`}}>
           <GiCrownCoin className="giCrownCoin"/> <span className="ptsSpan">{library.points} Points</span>
            </div>
              <div className="cardInImg">
              <div className="cardInfo">
                <h4 className="cardInfoH4">{library.model3d?.modelName} </h4>
              </div>
              </div>
          </div>)}
        </div>
        {open? popRedeem(): null }  
       {!data[0] ?  null :
       <div className="flex items-center justify-center mt-6 mb-8 gap-3 bottom-0 ">
        <button
          className="px-4 py-2 bg-gray-200 rounded-lg disabled:opacity-50"
          disabled={page === 1}
          onClick={() => setPage((p) => p - 1)}
        >
          Previous
        </button>

        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            className={`min-w-[40px] px-3 py-2 rounded-lg ${
              page === i + 1
                ? "pagination-active"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
            onClick={() => setPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}

        <button
          className="px-4 py-2 bg-gray-200 rounded-lg disabled:opacity-50"
          disabled={page === totalPages}
          onClick={() => setPage((p) => p + 1)}
        >
          Next
        </button>
      </div>}    
      </div>      
  );
};

export default Library;
